<script setup>
import { storeToRefs } from 'pinia';

import CurrencyField from '@/components/forms/CurrencyField.ce.vue';
import InputField from '@/components/forms/InputField.ce.vue';

import { usePersonalizedTariffFormStore } from '@/store/forms/personalized_tariffs';
import { useTranslationsStore } from '@/store/translations';
import { computed, onBeforeMount } from 'vue';
import {isNumber} from "lodash-es";


const props = defineProps({
    cell: {
        type: Object,
        default: () => {
            return {
                defaultValue: 'Hello world',
                label: 'text here',
                modelFieldName: 'field-name',
                type: 'input',
            };
        },
    },
});

const formStore = usePersonalizedTariffFormStore();
const { formData } = storeToRefs(formStore);

const translationStore = useTranslationsStore();
const { currency, languageCode } = storeToRefs(translationStore);

const currencyOptions = computed(() => {
    return {
        currency: currency.value,
        locale: languageCode.value,
        hideCurrencySymbolOnFocus: false,
    };
});

const modelValue = computed({
    get() {
        return formData.value[props.cell.modelFieldName];
    },
    set(value) {
        formData.value[props.cell.modelFieldName] = value;
    },
});

onBeforeMount(function() {
    const defaultValue = props.cell['defaultValue'];
    if (isNumber(defaultValue)) {
        modelValue.value = defaultValue;
    }
});
</script>

<template>
    <div class="inline-block">
        <template v-if="props.cell.inputType === 'currency'">
            <CurrencyField
                v-model="modelValue"
                :options="currencyOptions"
            />
        </template>
        <template v-else>
            <InputField
                v-model="modelValue"
                :input-type="props.cell.inputType"
                :max-value="props.cell['maxValue']"
            />
        </template>
        <div class="font-light">{{ props.cell.label }}</div>
    </div>
<!--    <div>-->
<!--        <pre>-->
<!--            <code>{{props.cell}}</code>-->
<!--        </pre>-->
<!--    </div>-->
</template>
